export default __webpack_public_path__ + "static/media/checkbox_checked.e40be716.svg";